/**
 * Search semantics for `ra-search-bar-field`: ordered subsequence match,
 * case-insensitive. Every character in `query` (including `_`, `-`, etc.) must
 * appear in `text` in the same order; gaps are allowed.
 */
export function matchesSearchBarQuery(text: string, query: string): boolean {
  const q = query?.trim() ?? '';
  if (!q) {
    return true;
  }
  const L = text.toLowerCase();
  const Q = q.toLowerCase();
  let qi = 0;
  for (let i = 0; i < L.length && qi < Q.length; i++) {
    if (L[i] === Q[qi]) {
      qi++;
    }
  }
  return qi === Q.length;
}

/**
 * Filters a list using the same rules as `ra-search-bar-field`. When `query` is
 * empty or whitespace-only, returns all items (shallow copy).
 */
export function filterBySearchBarQuery<T>(
  items: readonly T[],
  query: string,
  getSearchableText: (item: T) => string,
  options?: { alwaysInclude?: (item: T) => boolean },
): T[] {
  const q = query?.trim() ?? '';
  if (!q) {
    return [...items];
  }
  const alwaysInclude = options?.alwaysInclude;
  return items.filter((item) => {
    if (alwaysInclude?.(item)) {
      return true;
    }
    return matchesSearchBarQuery(getSearchableText(item), q);
  });
}
